import React from 'react'

export default function DomainSettingsInfoModal({close}) {
  return (
    <div>
        <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
            <div className="bg-white mx-auto rounded shadow p-5 text-center">
                <div>
                    <p style={{marginBottom: "0px"}}><b>To create a CNAME record with a subdomain pointing to giveclarity.co, follow these steps:</b></p>
                    <ol style={{listStylePosition: "inside", textAlign: "left"}}>
                        <li>Add the domain you will like to use in the custom domain field e.g "subdomain.domain.com"</li>
                        <li>Log in to your domain registrar's control panel or DNS hosting provider.</li>
                        <li>Locate the DNS management or DNS settings section.</li>
                        <li>Look for an option to add a new record or CNAME record.</li>
                        <li>Enter the subdomain you added to Clarity (e.g., "subdomain" for "subdomain.domain.com").</li>
                        <li>Set the record type to CNAME.</li>
                        <li>Copy the DNS Target in the settings here and paste in the "Value" or "Points to" field.</li>
                        <li>Save or update the DNS settings.</li>
                    </ol>
                    <p className='text-danger'>
                        <b>Note: </b>It might take from a couple minutes to 48 hours before your DNS changes are propagated by your domain provider and your 
                        public pages will be down for that period of time.
                    </p>
                </div>
                <div className="pt-3">
                    <button onClick={close} type="button" className="btn btn-secondary mr-2">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
  )
}
